/*
 * tc-ship-progress.js
 * -------------------
 * Keeps the announcement-bar rewards message ("$12.40 away from FREE SHIPPING")
 * in step with the cart when there is no page reload.
 *
 * The initial message is server-rendered by snippets/tc-ship-progress.liquid.
 * This script only ever RE-renders it, from the same tier config, so the bar and
 * the slide cart can never disagree.
 *
 * Triggers:
 *   - 'teeccino:cart-refreshed'  -> fired by tc-cart.js after every cart mutation
 *   - Dawn pub/sub 'cart-update' -> belt and braces for non-slide-cart paths
 *   - once on load if a cart cookie exists -> corrects a stale full-page-cache render
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-tc-shipbar]');
  var cfgEl = document.querySelector('[data-tc-shipbar-config]');
  if (!bar || !cfgEl) return;

  var msgEl = bar.querySelector('[data-tc-shipbar-msg]');
  var host = bar.closest('.utility-bar') || bar.parentElement;
  if (!msgEl || !host) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var tiers = (cfg.tiers || [])
    .filter(function (t) {
      return t && t.th > 0 && t.copy;
    })
    .sort(function (a, b) {
      return a.th - b.th;
    });
  if (!tiers.length) return;

  // Shopify money formatting. Supports the four money_format placeholders a US
  // store can be set to; anything unrecognised falls through to plain dollars.
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = Math.max(0, Math.round(cents));

    function group(num) {
      return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    function withDecimals(useComma) {
      var whole = Math.floor(value / 100).toString();
      var frac = ('0' + (value % 100)).slice(-2);
      return (useComma ? group(whole) : whole) + '.' + frac;
    }
    function noDecimals(useComma) {
      var whole = Math.round(value / 100).toString();
      return useComma ? group(whole) : whole;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount':
          return withDecimals(true);
        case 'amount_no_decimals':
          return noDecimals(true);
        case 'amount_with_comma_separator':
          return withDecimals(false).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return noDecimals(false);
        default:
          return withDecimals(true);
      }
    });
  }

  function setActive(on) {
    bar.dataset.active = on ? 'true' : 'false';
    host.classList.toggle('tc-shipbar-on', !!on);
  }

  function render(cart) {
    if (!cart || !cart.item_count) {
      setActive(false);
      return;
    }

    // Donation lines never count toward reward tiers (matches tc-cart.js).
    var total = (cart.items || []).reduce(function (sum, i) {
      return i.product_type === 'Donation' ? sum - (i.final_line_price || 0) : sum;
    }, cart.total_price || 0);
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (total < tiers[i].th) {
        next = tiers[i];
        break;
      }
    }

    var msg = next
      ? next.copy.replace('[amount]', formatMoney(next.th - total, cfg.moneyFormat))
      : cfg.complete;

    if (!msg) {
      setActive(false);
      return;
    }

    msgEl.textContent = msg;
    setActive(true);
  }

  var timer = null;
  var inFlight = false;
  function sync() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (inFlight) return;
      inFlight = true;
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (cart) {
          if (cart) render(cart);
        })
        .catch(function () {
          /* network hiccup: leave whatever is on screen rather than blanking it */
        })
        .then(function () {
          inFlight = false;
        });
    }, 120);
  }

  document.addEventListener('teeccino:cart-refreshed', sync);
  document.addEventListener('cart:refresh', sync);

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, sync);
  }

  // Reconcile once on load only when a cart cookie exists, so a page served from
  // Shopify's full-page cache with a stale total corrects itself without adding a
  // request for every first-time visitor.
  if (/(^|;\s*)cart=/.test(document.cookie)) sync();
})();
